const fromdata = [
	{
		inputdata: '',
		title: '权限名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: '',
		title: '权限编码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: '',
		title: '描述',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: "1",
		title: "优先级",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numberAL",
		width: "490px",
		min: 1,
		max: 5000,
	},
]
export default fromdata;
